const bpoints = {
    mobile: {
        // w: 515,
        w: 650,
    },
    tablet: {
        w: 900,
    }
}

// Función para determinar si es móvil
export const isMobile = () => {
    if (typeof window !== 'undefined') {
        return window.innerWidth <= bpoints.mobile.w;
    }
    return false;
}

// Función para obtener minWidth basado en el dispositivo
export const getMinWidth = () => {
    return isMobile() ? '250px' : '430px';
}

export {
    bpoints
}